import { MapContextState } from 'Plugins/FloorPlan/Context/MapContext';
import { MapHelper } from 'Plugins/FloorPlan/Helpers/MapHelper';
import { RoomType } from 'Plugins/FloorPlan/Models/IRoom';
import { IRoomItem } from 'Plugins/FloorPlan/Models/IRoomItem';

export const getMapByType = ({ type, rooms = [], ...rest }: Partial<MapContextState>) => {
    const { openings, roomItems } = MapHelper.getRoomAllElements(rooms);
    const roomsByType = rooms.filter((r) => r.type === type);
    const wallsByType = roomsByType.filter((r) => r.type === type).flatMap((r) => r.walls);
    const roomsIdsByType = roomsByType.map((x) => x.roomId!);
    const openingsByType = openings!.filter((x) => roomsIdsByType.includes(x.roomId!));
    const roomItemsByType = roomItems!.filter((x) => x.roomId === undefined || roomsIdsByType.includes(x.roomId));
    const laizePropsByType = (rest.laizeProps || []).filter((lp) =>
        lp.roomIds?.some((roomId) => roomsByType.map((r) => r.roomId!).includes(roomId))
    );

    return {
        ...rest,
        type,
        walls: wallsByType,
        rooms: roomsByType,
        openings: openingsByType,
        roomItems: roomItemsByType,
        roomsIdsByType,
        laizePropsByType
    };
};
export const getMapItemsByType = ({ rooms: mapRooms = [], ...rest }: Partial<MapContextState>, type: RoomType) => {
    const { rooms, openings, roomItems } = MapHelper.getRoomAllElements(mapRooms);

    const roomsByType = rooms!.filter((r) => r.type === type);
    const roomsIdsByType = roomsByType.map((x) => x.roomId!);
    const opneningsByType = openings!.filter((x) => roomsIdsByType.includes(x.roomId!));
    const roomItemsByType = roomItems!.filter((x) => roomsIdsByType.includes(x.roomId!));
    const wallsByType = roomsByType.filter((r) => r.type === type).flatMap((r) => r.walls);
    return {
        ...rest,
        type,
        walls: wallsByType,
        rooms: roomsByType,
        openings: opneningsByType,
        roomItems: roomItemsByType,
        roomsIdsByType,
    };
};

export const getMaps = (mapState: Partial<MapContextState>) => {
    return {
        sol: getMapItemsByType(mapState, RoomType.Sol),
        wall: getMapItemsByType(mapState, RoomType.Wall),
        stairs: getMapItemsByType(mapState, RoomType.Stairs),
    };
};

export const toUpdatedRoomItems = (roomItem: IRoomItem, { rooms = [] }: Partial<MapContextState>) => {
    const roomItems = MapHelper.getRoomItems(rooms);
    const updatedRoomItems = roomItems.map((r) => {
        return r.roomItemId === roomItem.roomItemId ? roomItem : r;
    });
    return updatedRoomItems;
};

export const toUpdatedMapState = (currentState: Partial<MapContextState>, updatedState: Partial<MapContextState>) => {
    const { rooms: currentRooms = [] } = currentState;
    const { rooms: updatedRooms = [] } = updatedState;

    const rooms = currentRooms.map((room) => {
        const updatedRoom = updatedRooms.find((r) => r.roomId === room.roomId);
        return updatedRoom || room;
    });
    return { rooms };
};
